import React  from "react";

const SmallCard =() =>{
return <>
              
              <div className="create-card add-cursor">
                <div className="create-card-icon">
       
                 
                </div> <div className="create-card-text">
                    <div className="create-card-title">
                    <div className="text-linetw"></div> 
                 
                    </div> 
                    <div className="create-card-description">
                    <div className="text-description">
              
              </div>
                    </div> 
                </div><div className="create-card-arrow">
                   
                </div> </div>
              
              
              
              
              
              
              
              </>
}

export default SmallCard;